export default {
  hero_title: '色即是空',
  hero_subtitle: '感悟般若智慧的修行之道',
  hero_description: '「色即是空」出自《心经》核心偈语，揭示万物本质皆为空性的佛教哲学智慧。放下执念、洞见本心，体悟空性之美。',
  hero_cta_articles: '探索智慧文章',
  hero_cta_about: '了解我们',
  section_featured: '精选文章',
  section_featured_desc: '深入浅出的般若智慧解读，帮助你从理解走向体证',
  section_categories: '分类探索',
  section_categories_desc: '从不同维度走近空性智慧，找到属于你的修行路径',
  section_faq: '常见疑问',
  section_faq_desc: '关于「色即是空」与般若智慧，你可能有的疑问都在这里',
  section_testimonials: '修行者说',
  section_testimonials_desc: '听听他们如何在生活中践行空性智慧',
  section_newsletter: '与智慧同行',
  section_newsletter_desc: '订阅我们的通讯，每周获取一篇精选般若智慧文章，让修行融入日常。',
  newsletter_placeholder: '请输入你的邮箱地址',
  newsletter_button: '免费订阅',
  newsletter_success: '订阅成功！欢迎加入般若智慧修行社群。',
  view_all_articles: '浏览全部文章',
  explore_category: '探索此分类',
  faq_schema_context: 'https://schema.org',
  faq_schema_type: 'FAQPage',
};